import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  usersListData: [],
  notification: [],
  selectedChat: [],
  taskList: null,
  attendanceList: null,
  projectsList: null,
  refresh: 0,
  renderCount: 0,
  unreadChatsCount: 0,
  attendanceListData: [],
  renderProgressBar: 0,
  preloaderVisible: true,
  disabledAllButtons: false,
  socketConnected: false,
  showCallModal: false,
  callDetails: null,
  callData: null,
  chatList: [],
  platform: 'web'
}

export const dataSlice = createSlice({
  name: 'data',
  initialState,
  reducers: {
    setCallData: (state, action) => {
      state.callData = action.payload
    },
    setChatList: (state, action) => {
      state.chatList = action.payload
    },
    setSelectedChat: (state, action) => {
      state.selectedChat = action.payload
    },
    setShowCallModal: (state, action) => {
      state.showCallModal = action.payload
    },
    setCallDetails: (state, action) => {
      state.callDetails = action.payload
    },
    setNotification: (state, action) => {
      state.notification = action.payload
    },
    setSocketConnected: (state, action) => {
      state.socketConnected = action.payload
    },

    setUsersListData: (state, action) => {
      const { usersListData } = action.payload
      state.usersListData = usersListData
    },
    setUsersList: (state, action) => {
      const { usersList } = action.payload
      state.usersList = usersList
    },
    setTasksList: (state, action) => {
      const { taskList } = action.payload
      state.taskList = taskList
    },
    setAttendanceList: (state, action) => {
      const { attendanceList } = action.payload
      state.attendanceList = attendanceList
    },
    setAttendanceListData: (state, action) => {
      const { attendanceListData } = action.payload
      state.attendanceListData = attendanceListData
    },
    setProjectsList: (state, action) => {
      const { projectsList } = action.payload
      state.projectsList = projectsList
    },
    setRefresh: (state, action) => {
      state.refresh = action.payload
    },
    setRenderCount: (state, action) => {
      const { renderCount } = action.payload
      state.renderCount = renderCount
    },
    setRenderProgressBar: (state, action) => {
      const { renderProgressBar } = action.payload
      state.renderProgressBar = renderProgressBar
    },
    setUnreadChatsCount: (state, action) => {
      state.unreadChatsCount = action.payload
    },
    showPreloader: (state, action) => {
      const { preloaderVisible } = action.payload
      state.preloaderVisible = preloaderVisible
    },
    actionDisabledAllButtons: (state, action) => {
      const { disabledAllButtons } = action.payload
      state.disabledAllButtons = disabledAllButtons
    }
  }
})

export const {
  setUsersListData,
  setUsersList,
  setTasksList,
  setAttendanceList,
  setAttendanceListData,
  setProjectsList,
  setRefresh,
  setRenderCount,
  setRenderProgressBar,
  showPreloader,
  setUnreadChatsCount,
  actionDisabledAllButtons,
  setSelectedChat,
  setNotification,
  setSocketConnected,
  setShowCallModal,
  setCallDetails,
  setChatList,
  setCallData
} = dataSlice.actions

export default dataSlice.reducer
